import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-bold text-lg mb-4 flex items-center gap-2">
              <span className="fas fa-place-of-worship text-3xl text-white"></span>{" "}
              Venkatadri Seva Trust (R)
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Venkatadri Seva Trust is a non-profit charitable organization
              dedicated to bringing hope, dignity, and happiness to the lives of
              the underprivileged. Inspired by the timeless values of compassion
              and selfless service, the Trust reaches out to those in need,
              regardless of caste, creed, or religion.
            </p>
            <p className="text-gray-500 text-xs mt-2 italic">
              "Together We Serve • Together We Care • Together We Transform Lives."
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/" className="hover:text-primary transition">Home</Link></li>
              <li><Link to="/overview" className="hover:text-primary transition">About Us</Link></li>

              <li><Link to="/contact" className="hover:text-primary transition">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-3">Get Involved</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/donate" className="hover:text-primary transition">Donate Now</Link></li>
              {/* <li><Link to="/volunteer" className="hover:text-primary transition">Volunteer</Link></li> */}
              <li><Link to="/donor-benefits" className="hover:text-primary transition">Become A Donor</Link></li>

            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-3">Connect</h4>
            <div className="flex gap-4 text-gray-400">
              <a href="#" className="hover:text-primary"><i className="fab fa-facebook-f"></i></a>
              <a href="#" className="hover:text-primary"><i className="fab fa-twitter"></i></a>
              <a href="#" className="hover:text-primary"><i className="fab fa-instagram"></i></a>
              <a href="#" className="hover:text-primary"><i className="fab fa-youtube"></i></a>
            </div>
            <p className="text-gray-400 text-sm mt-3">
              <i className="fas fa-phone mr-1"></i>080-26623007 / +91 98869 77701 / +91 95351 50008
              <br />
              <i className="fas fa-envelope mr-1"></i>{" "}
              info@venkatadrisevatrust.com
            </p>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400 text-sm">
          &copy; 2010 Venkatadri Seva Trust (R). All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;